import * as React from 'react';

export interface LinkContextProps {
  domainName: string;
}

export const LinkContext = React.createContext<Partial<LinkContextProps>>({});
